import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import { useAppStore } from '@/store/app'
import { setPageSeo, setSiteIcon, toAbsoluteUrl } from '@/utils/seo'
import '@/assets/styles/index.scss'
import '@/assets/styles/portal.scss'
import '@/assets/styles/admin.scss'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)

// 运行时异常统一写入控制台，避免开发环境错误展示影响当前页面操作。
app.config.errorHandler = (error, _instance, info) => {
  console.error(`[Vue runtime error] ${info}`, error)
}

const appStore = useAppStore(pinia)

function syncDocumentMeta(route) {
  const pageTitle = route.meta?.title || ''
  const siteName = appStore.siteName
  const isHome = route.name === 'Home'
  const title = isHome ? siteName : [pageTitle, siteName].filter(Boolean).join(' - ')
  const baseUrl = window.location.origin
  const canonical = toAbsoluteUrl(route.path || '/', baseUrl)
  const descriptionKey = route.meta?.seoDescriptionKey
  const description = descriptionKey
    ? appStore.pageDescriptions[descriptionKey]
    : appStore.site.description
  setSiteIcon(toAbsoluteUrl(appStore.site.icon, baseUrl))
  setPageSeo({
    title: title || '加载中…',
    description,
    keywords: appStore.site.keywords,
    image: toAbsoluteUrl(appStore.site.logo, baseUrl),
    url: canonical,
    type: 'website'
  })
}

router.afterEach((route) => syncDocumentMeta(route))
appStore.$subscribe(() => syncDocumentMeta(router.currentRoute.value))
const bootstrapTask = appStore.initialize()
app.mount('#app')

bootstrapTask
  .catch(() => {
    // 网络错误已由请求层提示；全局覆盖层保留重试入口。
  })
  .finally(() => syncDocumentMeta(router.currentRoute.value))
